var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Weather',{attrs:{"show":_vm.show,"ref_weather":_vm.ref_weather,"interval":_vm.interval,"intervalOnMounted":_vm.intervalOnMounted,"duration":_vm.duration,"transition_name":_vm.transition_name},on:{"weather-ready":_vm.emitReady,"weather-end":_vm.emitEnd}})
}
var staticRenderFns = []

export { render, staticRenderFns }